const convertHoursIntoHourMinutes = (decimalHours) => {
  const hours = Math.floor(decimalHours);
  const minutes = Math.round((decimalHours - hours) * 60);
  const paddedMinutes = minutes < 10 ? '0' + minutes : minutes;
  const amPm = hours % 24 >= 12 ? 'PM' : 'AM';
  const displayHours = hours % 12 === 0 ? 12 : hours % 12;
  return `${displayHours}:${paddedMinutes} ${amPm}`;
};

export default convertHoursIntoHourMinutes;
